module.exports = __webpack_public_path__ + "img/logo-white.d1cd37bf.jpeg";